import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'audio-timmer',
  templateUrl: './audio-timmer.component.html',
  styleUrls: ['./audio-timmer.component.css']
})
export class AudioTimmerComponent implements OnInit {
  public anni: String;
  @Output() timmerEnd: any = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
    this.getCountDown();
  }

  public interval1: any;
  public coundDuration = 10;
  getCountDown() {
    let countdownNumberEl = document.getElementById('countdown-number');
    let countdown = 3;
    this.anni = 'countdown ' + (countdown + 1) + 's linear infinite forwards'
    countdownNumberEl.textContent = countdown.toString();
    clearInterval(this.interval1);
    this.interval1 = setInterval(() => {
      if (countdown <= 0) {
        this.timmerEnd.emit();
        // this.timmerEnd.emit(this.isCountDown);
        clearInterval(this.interval1);

      } else {
        countdown = --countdown;
        countdownNumberEl.textContent = countdown.toString();
      }
    }, 1000);
    console.log(countdown)

  }

}
